import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../Components/UI/select";
import { Label } from "../Components/UI/label";
import { IncidentQueryField, OrderByCriteria } from "../types/salesforce";

interface OrderBySelectorProps {
  className?: string;
  selectedFields: any[];
  availableFields: IncidentQueryField[];
  orderBy: OrderByCriteria | null;
  onOrderByChange: (orderBy: OrderByCriteria | null) => void;
}

export const OrderBySelector: React.FC<OrderBySelectorProps> = ({
  className,
  selectedFields,
  availableFields,
  orderBy,
  onOrderByChange,
}) => {
  const availableOrderFields = availableFields.filter((field) =>
    selectedFields.includes(field.Field_API_Name__c)
  );

  return (
    <div className={`space-y-2 rounded bg-white-main p-4 ${className}`}>
      <div className="flex items-center gap-2">
        <Label className="text-gray-600">Field Order</Label>
      </div>

      <div className="flex flex-col space-y-2 sm:flex-row sm:space-x-2 sm:space-y-0">
        <Select
          value={orderBy?.fieldName || ""}
          onValueChange={(value) => {
            if (!value || value === "_none") {
              onOrderByChange(null);
              return;
            }
            onOrderByChange({
              fieldName: value,
              direction: orderBy?.direction || "ASC",
            });
          }}
        >
          <SelectTrigger className="w-full sm:w-[180px]">
            <SelectValue placeholder="Select field" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="_none">None</SelectItem>
            {availableOrderFields.map((field) => (
              <SelectItem
                key={field.Field_API_Name__c}
                value={field.Field_API_Name__c}
              >
                {field.Label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        {orderBy && (
          <Select
            value={orderBy.direction}
            onValueChange={(direction) =>
              onOrderByChange({
                ...orderBy,
                direction: direction as "ASC" | "DESC",
              })
            }
          >
            <SelectTrigger className="w-full sm:w-[120px]">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="ASC">Ascending</SelectItem>
              <SelectItem value="DESC">Descending</SelectItem>
            </SelectContent>
          </Select>
        )}
      </div>
    </div>
  );
};
